// TODO: Refactor for manageability
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { setGlobalMsg } from '../../actions/global-msg';
import { browserHistory } from 'react-router';
import _ from 'lodash';
import React, { Component, PropTypes } from 'react';
import { compose, graphql } from 'react-apollo';
import gql from 'graphql-tag';
import graphqlLib from '../../lib/graphql-lib';
import { formatDateForDisplay } from '../../lib/date-format-lib';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import {
	Badge,
	Button,
	ButtonGroup,
	CopyIcon,
	Icon,
	Loader,
	Pagination,
	SearchBar,
	Spinner,
	Switch,
	Table,
	Tooltip,
} from './../../components';
import AddEditFeedPane from './AddEditPane';
import LinkCorporationPane from './LinkCorporationPane';

// Import the CSS
import '../../../scss/containers/feeds/_list.scss';

const DEFAULT_LIMIT = 10;
const SORT_BY_ISSUES = 'ISSUES_DESC';
const SORT_BY_NAME = 'NAME_ASC';
const NHF_SOURCE_URL = 'feeds.newhomefeed.com/zillow/6.Zillow.';
const SECURE_PROTOCOL = 'https://';
const UNSECURE_PROTOCOL = 'http://';

export class FeedList extends Component {
	static propTypes = {
		user: PropTypes.shape({
			can: PropTypes.func.isRequired,
			id: PropTypes.string,
			isAdmin: PropTypes.func,
		}).isRequired,
		location: PropTypes.object,
		deleteFeed: PropTypes.func,
		updateForceFeed: PropTypes.func,
		updateResetBaseline: PropTypes.func,
		forcePhoenixRun: PropTypes.func,
		feedListQuery: PropTypes.object,
		actions: PropTypes.object,
		reactivateFeed: PropTypes.func,
		subdivisionBillingIdAlertQuery: PropTypes.object,
	};

	state = {
		tableView: 'feedList',
		showFeedPane: false,
		showCorporationPane: false,
		feed: null,
		deletingFeedIds: [],
		forceRunningFeedIds: [],
		forceRunningPhoenixFeedIds: [],
	};

	componentDidMount() {
		if (!this.props.user.can('view-feed-list')) {
			browserHistory.push('/');
		} else {
			browserHistory.push({
				...this.props.location,
				query: {
					...this.props.location.query,
					feedListPage: this.props.location.query.feedListPage || 1,
					alertsPage: this.props.location.query.alertsPage || 1,
					subdivisionAlertPage: this.props.location.query.subdivisionAlertPage || 1,
					filter: this.props.location.query.filter || '',
					includeDeletedFeeds: this.props.location.query.includeDeletedFeeds || 'true',
				},
			});
		}
	}

	handleClickAddFeed(e, feed) {
		e.preventDefault();
		this.setState({
			feed: null,
			showFeedPane: true,
		});
	}

	handleClickEditFeed(e, feed) {
		e.preventDefault();
		this.setState({
			showFeedPane: true,
			feed: feed,
		});
	}

	async handleClickDeleteFeed(feed, isDeleted) {
		if (!isDeleted) {
			if (
				confirm(
					'This feed, as well as all data associated with this feed, will be deleted.\n\nAre you sure?',
				)
			) {
				this.setState(
					{
						deletingFeedIds: [feed.id, ...this.state.deletingFeedIds],
					},
					async () => {
						await this.props.deleteFeed(feed.id);
						this.props.actions.setGlobalMsg(
							'success',
							`Feed #${feed.id} has been deleted!`,
						);
						this.fetchFeedList();
					},
				);
				this.setState({
					deletingFeedIds: this.state.deletingFeedIds.filter(f => {
						f.id !== feed.id;
					}),
				});
			}
		} else if (confirm('This will reactivate the feed.\n\nAre you sure?')) {
			const response = await this.props.reactivateFeed(feed.id);
			if (response.data) {
				this.props.actions.setGlobalMsg(
					'success',
					`Feed #${feed.id} has been reactivated!`,
				);
				this.fetchFeedList();
			} else {
				this.props.actions.setGlobalMsg('error', `Failed to reactivate Feed #${feed.id}.`);
			}
		}
	}

	handleClickForceBuilderDataRun(e, feed) {
		e.preventDefault();
		this.setState({
			forceRunningFeedIds: [feed.id, ...this.state.forceRunningFeedIds],
		});
		this.setState(async () => {
			await this.props.updateForceFeed(feed.id);
			this.setState({
				forceRunningFeedIds: this.state.forceRunningFeedIds.filter(f => {
					f.id !== feed.id;
				}),
			});
			this.props.actions.setGlobalMsg(
				'success',
				`Feed #${feed.id} has been forced to run! It will be processed during the next cycle.`,
			);
		});
	}

	handleClickResetBaseline(e, feed) {
		e.preventDefault();
		this.setState({
			forceRunningFeedIds: [feed.id, ...this.state.forceRunningFeedIds],
		});
		this.setState(async () => {
			await this.props.updateResetBaseline({
				id: feed.id,
				listingCountBaseline: feed.listingCountLastSeen,
			});
			this.setState({
				forceRunningFeedIds: this.state.forceRunningFeedIds.filter(f => {
					f.id !== feed.id;
				}),
			});
			this.props.actions.setGlobalMsg(
				'success',
				`Feed #${feed.id} has had baseline reset and been forced to run! It will be processed during the next cycle.`,
			);
			this.fetchFeedList();
		});
	}

	handleClickForcePhoenixRun(e, feed) {
		e.preventDefault();

		this.setState({
			forceRunningPhoenixFeedIds: [feed.id, ...this.state.forceRunningPhoenixFeedIds],
		});

		this.setState(async () => {
			await this.props.forcePhoenixRun(feed.id);
			this.setState({
				forceRunningPhoenixFeedIds: this.state.forceRunningPhoenixFeedIds.filter(f => {
					f.id !== feed.id;
				}),
			});
			this.props.actions.setGlobalMsg(
				'success',
				`Feed #${feed.id} has been forced to run in Phoenix!`,
			);
		});
	}

	handleClickViewParseReport(e, feed) {
		e.preventDefault();
		browserHistory.push({
			pathname: `/feeds/${feed.id}`,
			state: {
				feed: feed,
				pathInfo: [{ id: feed.id.toString(), name: feed.name }],
			},
		});
	}

	handleCloseFeedPane(refreshList = false) {
		this.setState({
			showFeedPane: false,
			feed: null,
		});
		if (refreshList) {
			this.fetchFeedList();
		}
	}

	handleClickEditCorporation(e, feed) {
		e.preventDefault();
		this.setState({
			feed,
			showCorporationPane: true,
		});
	}

	handleCloseCorporationPane(refreshList = false) {
		this.setState({
			showCorporationPane: false,
			feed: null,
		});
		if (refreshList) {
			this.fetchFeedList();
		}
	}

	handleChangeTableView(tableView) {
		switch (tableView) {
			case 'feedList': {
				this.setState(state => (state.tableView = 'feedList'));
				break;
			}
			case 'alerts': {
				this.setState(state => (state.tableView = 'alerts'));
				break;
			}
			case 'subdivisionAlerts': {
				this.setState(state => (state.tableView = 'subdivisionAlerts'));
				break;
			}
		}
	}

	handleChangeSearchFilter(filter) {
		browserHistory.push({
			...this.props.location,
			query: {
				...this.props.location.query,
				feedListPage: 1,
				alertsPage: 1,
				filter,
			},
		});
	}

	handleChangeFeedListPage(feedListPage) {
		browserHistory.push({
			...this.props.location,
			query: {
				...this.props.location.query,
				feedListPage,
			},
		});
	}

	handleChangeAlertsPage(alertsPage) {
		browserHistory.push({
			...this.props.location,
			query: {
				...this.props.location.query,
				alertsPage,
			},
		});
	}

	handleChangeSubdivisionAlertPage(subdivisionAlertPage) {
		browserHistory.push({
			...this.props.location,
			query: {
				...this.props.location.query,
				subdivisionAlertPage,
			},
		});
	}

	fetchFeedList() {
		this.props.feedListQuery.refetch();
		this.props.addDropAlertListQuery.refetch();
	}

	handleChangeIncludeDeletedFeeds() {
		browserHistory.push({
			...this.props.location,
			query: {
				...this.props.location.query,
				includeDeletedFeeds:
					this.props.location.query.includeDeletedFeeds === 'false' ? 'true' : 'false',
			},
		});
	}

	render() {
		const {
			feedListQuery,
			addDropAlertListQuery,
			subdivisionBillingIdAlertQuery,
			location: { query },
		} = this.props;
		const isFetchingFeeds = !feedListQuery ? false : feedListQuery.loading;
		const feedList = _.get(feedListQuery, 'feeds.results', []);
		const isFetchingAlerts = !addDropAlertListQuery ? false : addDropAlertListQuery.loading;
		const alertList = _.get(addDropAlertListQuery, 'feeds.results', []);
		const isFetchingSubdivisions = !subdivisionBillingIdAlertQuery
			? false
			: subdivisionBillingIdAlertQuery.loading;
		const subdivisionList = _.get(
			subdivisionBillingIdAlertQuery,
			'subdivisionsByInvalidBillingId.results',
			[],
		);
		const InvalidSubdivisionsCount = _.get(
			subdivisionBillingIdAlertQuery,
			'subdivisionsByInvalidBillingId.numTotal',
			'0',
		);
		let feedPaneTitle = this.state.feed ? `Edit Feed ID #${this.state.feed.id}` : 'Add a Feed';
		return (
			<div className="container">
				<div className="row row-thirds">
					<div className="cell">
						<h1>Feed Management</h1>
					</div>
					<div className="cell justify-left">
						{!!this.props.location.search &&
						(isFetchingFeeds || isFetchingAlerts || isFetchingSubdivisions) ? (
							<Loader />
						) : (
							<If condition={this.props.user.can('edit-feed-list')}>
								<Button action="add" onClick={e => this.handleClickAddFeed(e)}>
									Add
								</Button>
							</If>
						)}
					</div>
					<div className="cell justify-right">
						<SearchBar
							value={query.filter || ''}
							onEnter={filter => this.handleChangeSearchFilter(filter)}
						/>
					</div>
				</div>
				<div className="feed-list-header">
					<ButtonGroup
						selected={this.state.tableView}
						size="large"
						onChange={tableView => this.handleChangeTableView(tableView)}>
						<Button name="feedList">Feed List</Button>
						<Button name="alerts">
							Alerts
							<Badge shape="square" style={alertList.length > 0 ? 'error' : 'white'}>
								{addDropAlertListQuery && addDropAlertListQuery.feeds
									? addDropAlertListQuery.feeds.numTotal
									: '0'}
							</Badge>
						</Button>
						<Button name="subdivisionAlerts">
							Missing Billing ID Subdivisions
							<Badge
								data-testid="subdivision-alerts-badge"
								shape="square"
								style={subdivisionList.length > 0 ? 'error' : 'white'}>
								{InvalidSubdivisionsCount}
							</Badge>
						</Button>
					</ButtonGroup>
					{this.state.tableView === 'feedList' && (
						<div>
							<span className="feeds-list-controls-label">Include Deleted Feeds</span>
							<Switch
								onLabel="On"
								offLabel="Off"
								name="mark-all-switch"
								checked={query.includeDeletedFeeds !== 'false'}
								onChange={() => this.handleChangeIncludeDeletedFeeds()}
							/>
						</div>
					)}
				</div>
				<Choose>
					<When condition={this.state.tableView === 'feedList'}>
						<Choose>
							<When
								condition={
									feedList.length &&
									this.props.location.search &&
									!isFetchingFeeds
								}>
								<div className="table-container">
									<Table className="feeds-list">
										<thead>
											<tr>
												<th>ID (Output URL)</th>
												<th>Feed Name</th>
												<th>Source</th>
												<th>Last Completed</th>
												<If
													condition={this.props.user.can(
														'edit-feed-list',
													)}>
													<th className="small-header">Status</th>
													<th className="small-header">Edit</th>
													<th className="small-header">Link</th>
												</If>
												<If condition={this.props.user.isAdmin()}>
													<th className="small-header">
														Force Builder Data Run
													</th>
													<th className="small-header">
														Force Phoenix Data Run
													</th>
												</If>
												<th className="small-header">
													View Last Parse Report
												</th>
											</tr>
										</thead>
										<tbody>
											{feedList.map(feed => {
												const outputUrl = `${SYNDICATOR_PATH}feeds/${feed.id}`;
												const sourceUrl = feed.source;
												const isDeleted = feed.deletedAt != null;
												const shortenedURL = sourceUrl
													.replace(SECURE_PROTOCOL, '')
													.replace(UNSECURE_PROTOCOL, '')
													.replace(NHF_SOURCE_URL, '');
												return (
													<tr key={feed.id}>
														<td>
															{feed.id}
															<div className="copy-icon-container">
																<CopyIcon
																	copyText={outputUrl}
																	text="Copy this output url"
																/>
															</div>
														</td>
														<td>{feed.name}</td>
														<td className="source-url">
															{shortenedURL}
															<div className="copy-icon-container">
																<CopyIcon
																	copyText={feed.source}
																	text="Copy this source url"
																/>
															</div>
														</td>
														<td>
															<Choose>
																<When
																	condition={
																		feed.failureMessageDetail
																	}>
																	<Icon type="warning-circle" />
																	{feed.failureMessageDetail}
																</When>
																<When
																	condition={
																		feed.isAddDropProtected
																	}>
																	<Icon type="warning-circle" />
																	<div>
																		{
																			"Needs review. See 'Alerts'"
																		}
																	</div>
																</When>
																<When
																	condition={
																		feed.lastSucceededAt
																	}>
																	<Icon type="check-circle" />
																	<span className="last-completed">
																		{formatDateForDisplay(
																			feed.lastSucceededAt,
																		)}
																	</span>
																</When>
																<Otherwise>
																	Feed has not been successfully
																	run
																</Otherwise>
															</Choose>
														</td>
														<If
															condition={this.props.user.can(
																'edit-feed-list',
															)}>
															<td className="gray-bg">
																<ReactCSSTransitionGroup
																	transitionName="delete"
																	transitionEnterTimeout={500}
																	transitionLeaveTimeout={500}>
																	<Choose>
																		<When
																			condition={this.state.deletingFeedIds.includes(
																				feed.id,
																			)}>
																			<Spinner key="spinner" />
																		</When>
																		<Otherwise>
																			<Switch
																				onLabel="Active"
																				offLabel="Deleted"
																				name={feed.name}
																				checked={!isDeleted}
																				onChange={() =>
																					this.handleClickDeleteFeed(
																						feed,
																						isDeleted,
																					)
																				}
																			/>
																		</Otherwise>
																	</Choose>
																</ReactCSSTransitionGroup>
															</td>
															<td className="gray-bg">
																<Choose>
																	<When
																		condition={this.state.deletingFeedIds.includes(
																			feed.id,
																		)}>
																		<Icon type="pencil" />
																	</When>
																	<Otherwise>
																		<a
																			href="#"
																			onClick={e =>
																				this.handleClickEditFeed(
																					e,
																					feed,
																				)
																			}>
																			<Icon type="pencil" />
																		</a>
																	</Otherwise>
																</Choose>
															</td>
															<td className="gray-bg">
																<a
																	href="#"
																	onClick={e =>
																		this.handleClickEditCorporation(
																			e,
																			feed,
																		)
																	}>
																	<Icon type="globe" />
																</a>
															</td>
														</If>
														<If condition={this.props.user.isAdmin()}>
															<td className="gray-bg">
																<ReactCSSTransitionGroup
																	transitionName="force-run"
																	transitionEnterTimeout={500}
																	transitionLeaveTimeout={500}>
																	<Choose>
																		<When
																			condition={this.state.deletingFeedIds.includes(
																				feed.id,
																			)}>
																			<Icon type="rocket" />
																		</When>
																		<When
																			condition={this.state.forceRunningFeedIds.includes(
																				feed.id,
																			)}>
																			<Spinner
																				key={`spinner-${feed.id}`}
																			/>
																		</When>
																		<Otherwise>
																			<Tooltip
																				style="icon"
																				text="Force this feed to run"
																				position="left">
																				<a
																					href="#"
																					onClick={e =>
																						this.handleClickForceBuilderDataRun(
																							e,
																							feed,
																						)
																					}>
																					<Icon type="rocket" />
																				</a>
																			</Tooltip>
																		</Otherwise>
																	</Choose>
																</ReactCSSTransitionGroup>
															</td>
															<td className="gray-bg">
																<ReactCSSTransitionGroup
																	transitionName="force-run"
																	transitionEnterTimeout={500}
																	transitionLeaveTimeout={500}>
																	<Choose>
																		<When
																			condition={this.state.deletingFeedIds.includes(
																				feed.id,
																			)}>
																			<Icon type="rocket" />
																		</When>
																		<When
																			condition={this.state.forceRunningPhoenixFeedIds.includes(
																				feed.id,
																			)}>
																			<Spinner
																				key={`spinner-${feed.id}`}
																			/>
																		</When>
																		<Otherwise>
																			<Tooltip
																				style="icon"
																				text="Force Phoenix Record Run"
																				position="left">
																				<a
																					href="#"
																					onClick={e =>
																						this.handleClickForcePhoenixRun(
																							e,
																							feed,
																						)
																					}>
																					<Icon type="rocket" />
																				</a>
																			</Tooltip>
																		</Otherwise>
																	</Choose>
																</ReactCSSTransitionGroup>
															</td>
														</If>
														<td className="gray-bg">
															{feed.hasParseReport ? (
																<div>
																	{feed.issuesCount > 0 && (
																		<span className="issues-count">
																			<Icon type="warning-circle" />
																			{feed.issuesCount}{' '}
																			Issues
																		</span>
																	)}
																	<Tooltip
																		style="icon"
																		text="View last parse report"
																		position="left">
																		<a
																			href="#"
																			onClick={e =>
																				this.handleClickViewParseReport(
																					e,
																					feed,
																				)
																			}
																			aria-label={`View parse report for ${feed.name}`}>
																			<Icon type="report" />
																		</a>
																	</Tooltip>
																</div>
															) : (
																<div>No parse report available</div>
															)}
														</td>
													</tr>
												);
											})}
										</tbody>
									</Table>
								</div>
								<Pagination
									currentPage={parseInt(query.feedListPage, 10) || 1}
									totalPages={Math.ceil(
										feedListQuery.feeds.numTotal / DEFAULT_LIMIT,
									)}
									onPageChange={page => this.handleChangeFeedListPage(page)}
								/>
							</When>
							<When
								condition={
									feedList.length === 0 &&
									this.props.location.search &&
									!isFetchingFeeds
								}>
								No matching feeds found.
							</When>
							<When condition={!this.props.location.search}>
								Use the search bar to locate feeds.
							</When>
						</Choose>
					</When>
					<When condition={this.state.tableView === 'alerts'}>
						<Choose>
							<When
								condition={
									alertList.length &&
									this.props.location.search &&
									!isFetchingAlerts
								}>
								<div className="table-container">
									<Table className="feeds-list">
										<thead>
											<tr>
												<th>ID (Output URL)</th>
												<th>Feed Name</th>
												<th>Source</th>
												<th>Last Completed</th>
												<th>Expected Listing Count</th>
												<th>Last Seen</th>
												<th>Reset Baseline</th>
											</tr>
										</thead>
										<tbody>
											{alertList.map(feed => {
												const outputUrl = `${SYNDICATOR_PATH}feeds/${feed.id}`;
												const sourceUrl = feed.source;
												const shortenedURL = sourceUrl
													.replace(SECURE_PROTOCOL, '')
													.replace(UNSECURE_PROTOCOL, '')
													.replace(NHF_SOURCE_URL, '');
												return (
													<tr key={feed.id}>
														<td>
															{feed.id}
															<div className="copy-icon-container">
																<CopyIcon
																	copyText={outputUrl}
																	text="Copy this output url"
																/>
															</div>
														</td>
														<td>{feed.name}</td>
														<td className="source-url">
															{shortenedURL}
															<div className="copy-icon-container">
																<CopyIcon
																	copyText={feed.source}
																	text="Copy this source url"
																/>
															</div>
														</td>
														<td>
															<Choose>
																<When
																	condition={
																		feed.failureMessageDetail
																	}>
																	<Icon type="warning-circle" />
																	{feed.failureMessageDetail}
																</When>
																<When
																	condition={
																		feed.lastSucceededAt
																	}>
																	<Icon type="check-circle" />
																	<span className="last-completed">
																		{formatDateForDisplay(
																			feed.lastSucceededAt,
																		)}
																	</span>
																</When>
																<Otherwise>
																	Feed has not been successfully
																	run
																</Otherwise>
															</Choose>
														</td>
														<td>{feed.listingCountBaseline}</td>
														<td>{feed.listingCountLastSeen}</td>
														<td className="gray-bg">
															<ReactCSSTransitionGroup
																transitionName="force-run"
																transitionEnterTimeout={500}
																transitionLeaveTimeout={500}>
																<Choose>
																	<When
																		condition={this.state.forceRunningFeedIds.includes(
																			feed.id,
																		)}>
																		<Spinner
																			key={`spinner-${feed.id}`}
																		/>
																	</When>
																	<Otherwise>
																		<Tooltip
																			style="icon"
																			text="Reset baseline and reprocess feed"
																			position="left">
																			<a
																				href="#"
																				onClick={e =>
																					this.handleClickResetBaseline(
																						e,
																						feed,
																					)
																				}>
																				<Icon type="rocket" />
																			</a>
																		</Tooltip>
																	</Otherwise>
																</Choose>
															</ReactCSSTransitionGroup>
														</td>
													</tr>
												);
											})}
										</tbody>
									</Table>
								</div>
								<Pagination
									currentPage={parseInt(query.alertsPage, 10) || 1}
									totalPages={Math.ceil(
										addDropAlertListQuery.feeds.numTotal / DEFAULT_LIMIT,
									)}
									onPageChange={page => this.handleChangeAlertsPage(page)}
								/>
							</When>
							<When
								condition={
									alertList.length === 0 &&
									this.props.location.search &&
									!isFetchingAlerts
								}>
								No Add/Drop protected feeds found.
							</When>
						</Choose>
					</When>
					<When condition={this.state.tableView === 'subdivisionAlerts'}>
						<Choose>
							<When condition={subdivisionList.length && !isFetchingSubdivisions}>
								<div className="table-container">
									<Table className="feeds-list">
										<thead>
											<tr>
												<th>Feed Name</th>
												<th>Corporation Name</th>
												<th>Corporation Number</th>
												<th>Division Name</th>
												<th>Division Number</th>
												<th>Subdivision Name</th>
												<th>Subdivision Number</th>
												<th>PLID</th>
											</tr>
										</thead>
										<tbody>
											{subdivisionList.map(subdivision => {
												return (
													<tr key={subdivision.id}>
														<td>
															<div className="subdivision-cell">
																{subdivision.sourceFeed.name}
															</div>
														</td>
														<td>
															<div className="subdivision-cell">
																{subdivision.corporation.name}
															</div>
														</td>
														<td>
															<div className="subdivision-cell">
																{subdivision.corporation.number}
															</div>
														</td>
														<td>
															<div className="subdivision-cell">
																{subdivision.builder.name}
															</div>
														</td>
														<td>
															<div className="subdivision-cell">
																{subdivision.builder.number}
															</div>
														</td>
														<td>
															<div className="subdivision-cell">
																{subdivision.name}
															</div>
														</td>
														<td>
															<div className="subdivision-cell">
																{subdivision.number}
															</div>
														</td>
														<td>
															<div className="subdivision-cell">
																{
																	Buffer.from(
																		subdivision.uniqueId,
																		'base64',
																	)
																		.toString()
																		.split(':')[1]
																}
															</div>
														</td>
													</tr>
												);
											})}
										</tbody>
									</Table>
									<Pagination
										currentPage={parseInt(query.subdivisionAlertPage, 10) || 1}
										totalPages={Math.ceil(
											InvalidSubdivisionsCount / DEFAULT_LIMIT,
										)}
										onPageChange={page =>
											this.handleChangeSubdivisionAlertPage(page)
										}
									/>
								</div>
							</When>
							<When
								condition={subdivisionList.length === 0 && !isFetchingSubdivisions}>
								No un-mapped subdivision found.
							</When>
						</Choose>
					</When>
				</Choose>
				<AddEditFeedPane
					title={feedPaneTitle}
					visible={this.state.showFeedPane}
					feed={this.state.feed}
					onClose={() => this.handleCloseFeedPane(true)}
					onNewFeed={feed => this.setState({ feed, showCorporationPane: true })}
				/>
				<LinkCorporationPane
					title="New Corporations Found"
					visible={this.state.showCorporationPane}
					feed={this.state.feed || {}}
					onClose={() => this.handleCloseCorporationPane()}
					onSubmit={() => this.setState({ showCorporationPane: false })}
				/>
			</div>
		);
	}
}

export const feedListQuery = gql`
	query FeedListQuery($filter: FeedFilters, $limit: Int, $skip: Int, $sort: [FeedOrderBy!]) {
		feeds(filter: $filter, limit: $limit, skip: $skip, sort: $sort) {
			results {
				id(raw: true)
				name
				source
				downloadType
				parseType
				isEnabled
				taskIds
				lastSucceededAt
				failureMessageDetail
				listingCountBaseline
				listingCountLastSeen
				isAddDropProtected
				issuesCount
				hasParseReport
				deletedAt
			}
			numTotal
		}
	}
`;

export const subdivisionBillingIdAlertQuery = gql`
	query subdivisionBillingIdAlertQuery($limit: Int, $skip: Int, $sort: [SubdivisionOrderBy!]) {
		subdivisionsByInvalidBillingId(limit: $limit, skip: $skip, sort: $sort) {
			results {
				id
				name
				number
				uniqueId
				corporation {
					name
					number
				}
				builder {
					name
					number
				}
				sourceFeed {
					name
				}
			}
			numTotal
		}
	}
`;

export const deleteFeedMutation = gql`
	mutation DeleteFeed($id: EncodedID!) {
		deleteFeed(id: $id) {
			id
		}
	}
`;

export const updateFeedMutation = gql`
	mutation UpdateFeed($input: UpdateFeedInput!) {
		updateFeed(input: $input) {
			id
		}
	}
`;

export const forcePhoenixFeedMutation = gql`
	mutation ForceFeed($id: EncodedID!) {
		forceFeed(id: $id) {
			id
		}
	}
`;

export default compose(
	connect(
		state => ({
			user: state.auth.user,
			feeds: state.feeds.list,
			isFetching: state.feeds.isFetching,
			pagination: state.feeds.pagination,
			forceRunningFeedIds: state.feeds.forceRunningFeedIds,
			forceRunningPhoenixFeedIds: state.feeds.forceRunningPhoenixFeedIds,
			deletingFeedIds: state.feeds.deletingFeedIds,
			error: state.feeds.error,
		}),
		dispatch => ({
			actions: {
				setGlobalMsg: bindActionCreators(setGlobalMsg, dispatch),
			},
		}),
	),
	graphql(feedListQuery, {
		name: 'feedListQuery',
		options: ({ location: { query } }) => ({
			fetchPolicy: 'network-only',
			variables: {
				filter: {
					query: query.filter ? `%${query.filter}%` : undefined,
					deletedAt: query.includeDeletedFeeds !== 'false' ? { ne: null } : { eq: null },
				},
				limit: DEFAULT_LIMIT,
				skip: (query.feedListPage || 1) * DEFAULT_LIMIT - DEFAULT_LIMIT,
				sort: [SORT_BY_ISSUES, SORT_BY_NAME],
			},
		}),
	}),
	graphql(feedListQuery, {
		name: 'addDropAlertListQuery',
		options: ({ location: { query } }) => ({
			fetchPolicy: 'network-only',
			variables: {
				filter: {
					isAddDropProtected: { eq: true },
					query: query.filter ? `%${query.filter}%` : undefined,
				},
				limit: DEFAULT_LIMIT,
				skip: (query.alertsPage || 1) * DEFAULT_LIMIT - DEFAULT_LIMIT,
			},
		}),
	}),
	graphql(subdivisionBillingIdAlertQuery, {
		name: 'subdivisionBillingIdAlertQuery',
		options: ({ location: { query } }) => ({
			fetchPolicy: 'network-only',
			variables: {
				limit: DEFAULT_LIMIT,
				skip: (query.subdivisionAlertPage || 1) * DEFAULT_LIMIT - DEFAULT_LIMIT,
				sort: [SORT_BY_NAME],
			},
		}),
	}),
	graphql(deleteFeedMutation, {
		props: ({ mutate }) => ({
			deleteFeed: feedId =>
				mutate({
					variables: {
						id: graphqlLib.encodeId('feed', feedId),
					},
				}),
		}),
	}),
	graphql(updateFeedMutation, {
		props: ({ mutate }) => ({
			updateForceFeed: feedId =>
				mutate({
					variables: {
						input: {
							id: graphqlLib.encodeId('feed', feedId),
							verificationHash: null,
						},
					},
				}),
		}),
	}),
	graphql(updateFeedMutation, {
		props: ({ mutate }) => ({
			updateResetBaseline: args =>
				mutate({
					variables: {
						input: {
							id: graphqlLib.encodeId('feed', args.id),
							isAddDropProtected: false,
							listingCountBaseline: args.listingCountBaseline,
							verificationHash: null,
						},
					},
				}),
		}),
	}),
	graphql(updateFeedMutation, {
		props: ({ mutate }) => ({
			reactivateFeed: feedId =>
				mutate({
					variables: {
						input: {
							id: graphqlLib.encodeId('feed', feedId),
							deletedAt: null,
						},
					},
				}),
		}),
	}),
	graphql(forcePhoenixFeedMutation, {
		props: ({ mutate }) => ({
			forcePhoenixRun: feedId =>
				mutate({
					variables: {
						id: graphqlLib.encodeId('feed', feedId),
					},
				}),
		}),
	}),
)(FeedList);



// WEBPACK FOOTER //
// ./src/assets/js/containers/feeds/List.js